<template>
  <!-- 招聘 -->
  <div class="kr-layout-content">
    <div class="content-left">
      <!--城市列表-->
      <div class="all-city">
        <!-- <div class="all">全部</div> -->
        <ul class="city-list">
          <li
            v-for="(item,index) in city"
            :key="index"
            :class="n==index?'active':''"
            @click="trans(index,item.id,null)"
          >{{item.cityName}}</li>
        </ul>
      </div>

      <!--职位信息-->
      <div class="new-article">
        <div class="search">
          职位信息：
          <!--搜索框-->
          <div class="search-int">
            <input type="text" placeholder="请输入关键词" v-model="keyWord" v-on:keyup.enter="getSearch" />
            <i
              class="iconfont icon-sousuo-copy"
              style="width:25px;cursor:pointer;"
              @click="getSearch"
            ></i>
          </div>
        </div>

        <!--招聘列表-->
        <ul class="art-list">
          <li v-for="(item,index) in post" :key="index" @click="ptDetails(item.id)">
            <div class="head-img">
              <img :src="item.picUrl" alt />
            </div>
            <div class="content">
              <div class="title">
                <!-- <span>{{item.address}}</span> -->
                <p class="oneline" style="width:100%">{{item.title}}</p>
                <ul class="sea-list">
                  <li
                    v-for="(items,index) in item.tags.replace(new RegExp('，', 'g'),',').split(',')"
                    v-if="items != ''"
                    :key="index"
                  >{{items}}</li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loadmore" class="look-more" @click="More">查看更多</div>
        <p v-if="!loadmore" class="none-more">没有更多了</p>
      </div>
    </div>
    <!-- 推荐职位 -->
    <div class="content-right">
      <div class="top-img" style="margin-top:0px;">
        <img src="../../assets/img/msg.png" alt />推荐职位
      </div>
      <ul class="company-list">
        <li v-for="(item,index) in Recom" :key="index" @click="ptDetails(item.id)">
          <div class="company-img">
            <img :src="item.picUrl" alt />
          </div>
          <div class="cont">
            <p class="name">{{item.title}}</p>
            <p v-for="(items,index) in item.tags.split('，')" :key="index" class="func">· {{items}}</p>
          </div>
        </li>
      </ul>
      <div v-if="newsLoad" class="look-more" @click="inviteMore">查看更多</div>
      <p v-if="!newsLoad" class="none-more">没有更多了</p>
    </div>
  </div>
</template>
<script>
export default {
  //   name: "App",
  data() {
    return {
      city: [],
      n: 0,
      upload: "展开",
      isClass: true,
      act: false,
      id: null,
      post: [],
      Recom: [],
      keyWord: null,
      curPage: 1,
      newsPage: 1,
      loadmore: true,
      newsLoad: true,
      totalPage: 0,
      newsTotal: 0,
      tags: []
    };
  },
  mounted() {
    this.getCity();
    this.getPost(0, this.id, this.tj, this.keyWord);
    this.getRecom();
    // this.search()
  },
  methods: {
    getCity() {
      //获取城市列表
      this.$http.get("/api/zhaoPin/cityList").then(res => {
        console.log(res, "城市列表");
        if (res.status == 200 && res.data.code == 0) {
          this.city = res.data.rows;
        }
      });
    },
    trans(i, id) {
      this.id = id;
      this.n = i;
      this.curPage = 1;
      this.keyWord = "";
      this.post = [];
      this.loadmore = true;
      this.getPost();
    },
    getSearch(){
      this.curPage = 1;
      this.post = [];
      this.loadmore = true;
      this.getPost()
    },
    getPost() {
      //获取职位信息
      if (this.id == 3) {
        this.id = null;
        this.keyWord = null;
      }
      this.$http
        .get("/api/zhaoPin/zhaoPinList", {
          params: {
            cityId: this.id,
            // isTuiJian: 0,
            des: this.keyWord,
            pageNo: this.curPage,
          }
        })
        .then(res => {
          console.log(res, "职位信息");
          if (res.status == 200 && res.data.code == 0) {
            this.post = this.post.concat(res.data.rows);
            if (this.curPage >= res.data.totalPage) {
              this.loadmore = false;
            }
          }
        });
    },
    More() {
      //查看更多
      this.curPage++;
      this.getPost(this.id, this.keyWord);
    },
    getRecom() {
      //获取推荐信息
      this.$http
        .get("/api/zhaoPin/zhaoPinList", {
          params: {
            isTuiJian: 1,
            pageNo: this.newsPage
          }
        })
        .then(res => {
          console.log(res, "推荐列表");
          if (res.status == 200 && res.data.code == 0) {
            this.Recom = res.data.rows;
            if (this.newsPage >= res.data.totalPage) {
              this.newsLoad = false;
            }
            this.newsPage++;
          }
        });
    },
    inviteMore() {
      //查看更多
      this.getRecom();
    },
    addAct() {
      //展开收起
      this.act = !this.act;
    },
    ptDetails(id) {
      //招聘详情
      this.$router.push({ path: "/ptDetails", query: { id: id } });
    }
  }
};
</script>
<style scoped>
.new-article .art-list {
  padding: 10px;
}
.all-city .city-list {
  width: 100%;
  border: none;
}
@media (min-width: 1100px) and (max-width: 1279px) {
  .sea-list > li {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin: 8px 15px 5px 0px;
    padding: 0px 11px;
  }
  .sea-list > li.active {
    padding: 0px 12px;
  }
  .sea-list > li:hover {
    padding: 0px 12px;
  }
  .company-list li {
    height: 160px;
  }
}
@media (min-width: 800px) and (max-width: 1099px) {
  .sea-list > li {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin: 8px 15px 5px 0px;
    padding: 0px 11px;
  }
  .sea-list > li.active {
    padding: 0px 12px;
  }
  .sea-list > li:hover {
    padding: 0px 12px;
  }
  .company-list li {
    width: calc(50% - 10px);
    height: 200px;
    float: left;
  }
  .company-list li:nth-child(2n) {
    margin-left: 20px;
  }
}
@media (min-width: 720px) and (max-width: 799px) {
  .sea-list > li {
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    margin: 5px 10px 3px 0px;
    padding: 0px 11px;
  }
  .sea-list > li.active {
    padding: 0px 12px;
  }
  .sea-list > li:hover {
    padding: 0px 12px;
  }
  .company-list li {
    width: calc(50% - 10px);
    height: 180px;
    float: left;
  }
  .company-list li:nth-child(2n) {
    margin-left: 20px;
  }
}
@media (min-width: 640px) and (max-width: 719px) {
  .sea-list > li {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    margin: 5px 10px 3px 0px;
    padding: 0px 10px;
  }
  .sea-list > li.active {
    padding: 0px 11px;
  }
  .sea-list > li:hover {
    padding: 0px 11px;
  }
  .company-list li {
    width: calc(50% - 10px);
    height: 155px;
    float: left;
  }
  .company-list li:nth-child(2n) {
    margin-left: 20px;
  }
}
@media (min-width: 414px) and (max-width: 639px) {
  .sea-list > li {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    margin: 5px 10px 3px 0px;
    padding: 0px 10px;
  }
  .sea-list > li.active {
    padding: 0px 11px;
  }
  .sea-list > li:hover {
    padding: 0px 11px;
  }
}
@media (min-width: 320px) and (max-width: 414px) {
  .sea-list > li {
    height: 20px;
    line-height: 20px;
    margin: 3px 10px 3px 0px;
    padding: 0px 10px;
  }
  .sea-list > li.active {
    padding: 0px 11px;
  }
  .sea-list > li:hover {
    padding: 0px 11px;
  }
}
</style>